import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  Flex,
  Spacer,
  HStack,
  useTheme,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import AssignmentTable from "../../../components/table/assignmentTable/AssignmentTable";
import SearchBox from "../../../components/searchbox/SearchBox";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import UploadTimeTableModal from "../../../components/modals/AddModals/UploadTimetableModal";
import { extractFileName } from "../../../utils/extractFileNameFromUrl";
import { getAllTimetable } from "../../../store/slice/timetableSlice";
import { useDispatch, useSelector } from "react-redux";
const Timetable = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { primaryBlue } = theme.colors.pallete;
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [limit, setLimit] = useState(5);
  const { timetables, status } = useSelector((state) => state.timetables);
  useEffect(() => {
    dispatch(getAllTimetable());
  }, []);

  const transformedTimetables = timetables.map((item, index) => ({
    ...item,
    sno: index + 1,
    files: [{ url: item.url, name: extractFileName(item.url) }],
  }));

  const handleUploadTimetable = () => {
    onOpen();
  };

  return (
    <Box w={"100%"}>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Time Table
        </Text>
        <Spacer />
        <CourseTextButton
          text={"Upload Timetable"}
          onClick={handleUploadTimetable}
        />
      </Flex>
      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>
      </Flex>
      {status === "loading" ? (
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Spinner size="md" color="blue.500" />
        </Box>
      ) : status === "failed" ? (
        <Text>Failed to fetch the timetables</Text>
      ) : (
        <AssignmentTable
          data={transformedTimetables.slice(0, limit)}
          columnOrder={["sno", "files", "status"]}
          entityType="timetable"
          limit={limit}
        />
      )}

      <UploadTimeTableModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};

export default Timetable;
